var _defs, _rect, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHigherEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7499d6;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #445689;\n      }\n\n      .cls-3 {\n        fill: #d0f19a;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 256,
    height: 256
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 128,
    cy: 153,
    r: 40
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M192.66,119.89c-1.69.69-3.16,1.27-4.62,1.89-18.83,7.95-37.67,15.88-56.48,23.88-2.33.99-4.41,1-6.76,0-25.36-10.75-50.74-21.44-76.13-32.1-2.29-.96-3.78-2.42-3.77-4.94.02-2.52,1.56-3.94,3.84-4.89,25.59-10.67,51.17-21.38,76.73-32.11,1.83-.77,3.5-.82,5.35-.04,25.54,10.8,51.09,21.57,76.64,32.33,2.19.92,3.64,2.42,3.63,4.86-.01,2.44-1.44,3.95-3.65,4.84-2.52,1.02-4.99,2.14-7.51,3.15-.9.36-1.35.77-1.35,1.86.04,13.28.02,26.55.06,39.83,0,.53.25,1.28.65,1.55,4.06,2.73,5.1,10.07,3.5,14.4-.35.95-.38,2.17-.12,3.15,1.5,5.6,3.12,11.16,4.75,16.72.47,1.6.56,3.07-.97,4.15-1.46,1.04-2.74.42-4.09-.42-4.52-2.79-9.12-2.8-13.65-.03-1.41.86-2.72,1.56-4.24.41-1.44-1.08-1.23-2.51-.88-4.03,1.29-5.59,2.56-11.18,3.72-16.79.2-.94.04-2.05-.26-2.98-1.46-4.52-1-8.76,1.63-12.73.43-.66.99-1.47,1.66-1.69,2.56-.84,2.38-2.77,2.36-4.84-.06-11.05-.03-22.11-.03-33.16v-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.52,132.14c3.96,1.66,7.65,3.19,11.33,4.74,11.44,4.82,22.88,9.61,34.3,14.47,3.39,1.44,6.66,1.47,10.05.03,14.55-6.17,29.12-12.29,43.69-18.43.56-.23,1.13-.44,1.9-.74.05.74.12,1.32.12,1.9,0,8.64-.04,17.29.03,25.93.03,4.08-1.61,7.1-5.03,9.28-16.45,10.47-34.39,15.14-53.85,13.33-13.86-1.28-26.57-5.99-38.13-13.73-2.56-1.71-4.31-4.1-4.35-7.17-.13-9.75-.05-19.5-.05-29.63Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigherEducation);
export default __webpack_public_path__ + "static/media/Higher Education.d8d8e5771ce73caf1928a0840f98ed0c.svg";
export { ForwardRef as ReactComponent };